import $ from "jquery";
import "slick-carousel";

const contenctSliderCustomYoutube = () => {
  const init = () => {
    slick();
  };
  const slick = () => {
    const el = {
      carousel: ".js-mobile-four-slide-without-arrow",
    };

    if ($(el.carousel).length === 0) return;

    $(el.carousel).slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay : true,
      autoplaySpeed : 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  };

  init();
};
try {
  contenctSliderCustomYoutube();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
